import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-gray-100 text-gray-600 py-6 mt-auto text-center border-t border-gray-200">
      <div>
        &copy; {year} Needal. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
